import React from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import founder1 from "../../assets/images/founder-image1.jpeg";
import founder2 from "../../assets/images/founder-image2.jpeg";
import founder3 from "../../assets/images/founder-image3.jpeg";
import manager1 from "../../assets/images/team-image1.jpeg";
import manager2 from "../../assets/images/team-image2.jpeg";
import manager3 from "../../assets/images/team-image3.jpeg";
import defaultImage from "../../assets/images/default-user.jpg";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const OrganizationChart = () => {
  return (
    <div>
      <Navbar />
      <div className="page-header bg-[#F8F8F8] ">
        <div className="container">
          <h1 className="font-bold text-xl mb-3 text-[#003245]">
            Organizational Chart
          </h1>
          <ul className="flex gap-2">
            <Link to="/" className="text-sm text-[#003245]">
              Home
            </Link>
            <ChevronRightIcon sx={{ fontSize: "19px" }} />
            <Link to="/organizational-chart" className="text-sm text-[#003245]">
              Organizational Chart
            </Link>
          </ul>
        </div>
      </div>
      <div className="container pt-[5rem] pb-[5rem]">
        <div className="level-1 rectangle">
          <div className="flex org-team">
            <div className="ot-img">
              <img src={founder2} alt="Seyed Mahdi" />
            </div>
            <div className="ot-content">
              <h3>Seyed Mehdi</h3>
              <p>Founder / Director Sales</p>
              <a
                href="https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <WhatsAppIcon
                  sx={{
                    color: "#0DC143",
                    fontSize: "18px",
                  }}
                />
              </a>

              <a
                href="mailto:mehdi@agacrane.com?subject=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                target="_blank"
                className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                rel="noopener noreferrer"
              >
                <MailOutlineIcon
                  sx={{
                    color: "#F84E59",
                    fontSize: "18px",
                  }}
                />
              </a>
            </div>
          </div>
        </div>
        <ol className="level-2-wrapper">
          <li>
            <div className="level-2 rectangle">
              <div className="flex org-team">
                <div className="ot-img">
                  <img src={founder1} alt="Seyed Bagher" />
                </div>
                <div className="ot-content">
                  <h3>Seyed Bagher</h3>
                  <p>Founder, Director</p>
                  <a
                    href="https://wa.me/971501381984?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                    className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <WhatsAppIcon
                      sx={{
                        color: "#0DC143",
                        fontSize: "18px",
                      }}
                    />
                  </a>

                  <a
                    href="mailto:mousavi@agacrane.com?subject=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                    target="_blank"
                    className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                    rel="noopener noreferrer"
                  >
                    <MailOutlineIcon
                      sx={{
                        color: "#F84E59",
                        fontSize: "18px",
                      }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <ol className="level-3-wrapper">
              <li>
                <div className="level-3 rectangle">
                  <div className="flex org-team">
                    <div className="ot-img">
                      <img src={manager2} alt="Seyed Sajjad" />
                    </div>
                    <div className="ot-content">
                      <h3>Miss Zahra Akbar</h3>
                      <p>Sales Officer</p>
                      <a
                        href="https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                        className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsAppIcon
                          sx={{
                            color: "#0DC143",
                            fontSize: "18px",
                          }}
                        />
                      </a>

                      <a
                        href="mailto:zahra@agacrane.com?subject=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                        target="_blank"
                        className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                        rel="noopener noreferrer"
                      >
                        <MailOutlineIcon
                          sx={{
                            color: "#F84E59",
                            fontSize: "18px",
                          }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <ol className="level-4-wrapper">
                  <li>
                    <h4 className="level-4 rectangle">Person A</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person B</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person C</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person D</h4>
                  </li>
                </ol>
              </li>
              <li>
                <div className="level-3 rectangle">
                  <div className="flex org-team">
                    <div className="ot-img">
                      <img src={manager3} alt="Seyed Sajjad" />
                    </div>
                    <div className="ot-content">
                      <h3>Miss Masoumeh</h3>
                      <p>Sales Officer</p>
                      <a
                        href="https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                        className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsAppIcon
                          sx={{
                            color: "#0DC143",
                            fontSize: "18px",
                          }}
                        />
                      </a>

                      <a
                        href="mailto:masoumeh@agacrane.com?subject=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                        target="_blank"
                        className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                        rel="noopener noreferrer"
                      >
                        <MailOutlineIcon
                          sx={{
                            color: "#F84E59",
                            fontSize: "18px",
                          }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <ol className="level-4-wrapper">
                  <li>
                    <h4 className="level-4 rectangle">Person A</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person B</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person C</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person D</h4>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <div className="level-2 rectangle">
              <div className="flex org-team">
                <div className="ot-img">
                  <img src={founder3} alt="Seyed Sajjad" />
                </div>
                <div className="ot-content">
                  <h3>Seyed Sajjad</h3>
                  <p>Manager Workshop</p>
                  <a
                    href="https://wa.me/971501109828?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                    className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <WhatsAppIcon
                      sx={{
                        color: "#0DC143",
                        fontSize: "18px",
                      }}
                    />
                  </a>

                  <a
                    href="mailto:info@agacrane.com?subject=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                    target="_blank"
                    className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                    rel="noopener noreferrer"
                  >
                    <MailOutlineIcon
                      sx={{
                        color: "#F84E59",
                        fontSize: "18px",
                      }}
                    />
                  </a>
                </div>
              </div>
            </div>

            <ol className="level-3-wrapper">
              <li>
                <div className="level-3 rectangle">
                  <div className="flex org-team">
                    <div className="ot-img">
                      <img src={manager1} alt="Nazar Farid" />
                    </div>
                    <div className="ot-content">
                      <h3>Nazar Farid</h3>
                      <p>Manager Accounts</p>
                      <a
                        href="https://wa.me/971501102492?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                        className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsAppIcon
                          sx={{
                            color: "#0DC143",
                            fontSize: "18px",
                          }}
                        />
                      </a>
                      <a
                        href="mailto:nazar@agacrane.com?subject=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                        target="_blank"
                        className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                        rel="noopener noreferrer"
                      >
                        <MailOutlineIcon
                          sx={{
                            color: "#F84E59",
                            fontSize: "18px",
                          }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <ol className="level-4-wrapper">
                  <li>
                    <h4 className="level-4 rectangle">Person A</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person B</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person C</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person D</h4>
                  </li>
                </ol>
              </li>
              <li>
                <div className="level-3 rectangle">
                  <div className="flex org-team">
                    <div className="ot-img">
                      <img src={defaultImage} alt="User Name" />
                    </div>
                    <div className="ot-content">
                      <h3>Person Name</h3>
                      <p>Manager Workshop</p>
                      <a
                        href="https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                        className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsAppIcon
                          sx={{
                            color: "#0DC143",
                            fontSize: "18px",
                          }}
                        />
                      </a>

                      <a
                        href="mailto:info@agacrane.com?subject=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery."
                        target="_blank"
                        className="mt-1 inline-flex items-center justify-center h-[27px] w-[27px] rounded-full bg-white mr-2"
                        rel="noopener noreferrer"
                      >
                        <MailOutlineIcon
                          sx={{
                            color: "#F84E59",
                            fontSize: "18px",
                          }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <ol className="level-4-wrapper">
                  <li>
                    <h4 className="level-4 rectangle">Person A</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person B</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person C</h4>
                  </li>
                  <li>
                    <h4 className="level-4 rectangle">Person D</h4>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <Footer />
    </div>
  );
};

export default OrganizationChart;
